class urlParams {
  /**
   * @function getAllUrlParams - get params from querystring
   * @param {string} queryString - querystring parameters
   * @returns {object} - object with all params of the querystring argument
   */
  getAllUrlParams(queryString) {
    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {
      // stuff after # is not part of query string, so get rid of it
      queryString = queryString.split('#')[0];

      // split our query string into its component parts
      var arr = queryString.split('&');

      for (var i = 0; i < arr.length; i++) {
        // separate the keys and the values
        var a = arr[i].split('=');

        // in case params look like: list[]=thing1&list[]=thing2
        var paramNum = undefined;
        var paramName = a[0].replace(/\[\d*]/, function (v) {
          paramNum = v.slice(1, -1);
          return '';
        });

        // set parameter value (use 'true' if empty)
        var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

        // (optional) keep case consistent
        paramName = paramName;
        paramValue = paramValue;

        // if parameter name already exists
        if (obj[paramName]) {
          // convert value to array (if still string)
          if (typeof obj[paramName] === 'string') {
            obj[paramName] = [obj[paramName]];
          }
          // if no array index number specified...
          if (typeof paramNum === 'undefined') {
            // put the value on the end of the array
            obj[paramName].push(paramValue);
          }
          // if array index number specified...
          else {
            // put the value at that index number
            obj[paramName][paramNum] = paramValue;
          }
        }
        // if param name doesn't exist yet, set it
        else {
          obj[paramName] = paramValue;
        }
      }
    }

    return obj;
  }

  /**
   * @function removeParamFromUrl - remove param from url by key
   * @param {string} key - param key
   * @param {string} url - url with params
   * @returns {string} - url without param
   */
  removeParamFromUrl(key, url) {
    var rtn = url.split('?')[0];
    var param;
    var paramsarr = [];
    var queryString = (url.indexOf('?') !== -1) ? url.split('?')[1] : '';
    if (queryString !== '') {
      paramsarr = queryString.split('&');
      for (var i = paramsarr.length - 1; i >= 0; i -= 1) {
        param = paramsarr[i].split('=')[0];
        if (param === key) {
          paramsarr.splice(i, 1);
        }
      }
      rtn = rtn + '?' + paramsarr.join('&');
    }
    return rtn;
  }

  /**
   * @function removeParamFromUrl - remove param from url by key
   * @param {string} key - param key
   * @param {string} url - url with params
   * @returns {string} - url without param
   */
  replaceParamFromUrl(key, url, newparam) {
    if (!url) {
      return;
    }
    var rtn = url.split('?')[0];
    let found = false;
    var param;
    var paramsarr = [];
    var queryString = (url.indexOf('?') !== -1) ? url.split('?')[1] : '';
    if (queryString !== '') {
      paramsarr = queryString.split('&');
      for (var i = paramsarr.length - 1; i >= 0; i -= 1) {
        param = paramsarr[i].split('=')[0];
        if (param === key) {
          paramsarr[i] = param + '=' + newparam;
          found = true;
        }
      }
      if (!found) {
        paramsarr.push(key + '=' + newparam);
      }

      rtn = rtn + '?' + paramsarr.join('&');
    }
    return rtn;
  }

  addParam(url, param) {
    return (url || '').indexOf('?') !== -1 ? url + '&' + param : url + '?' + param;
  }
}

const UrlParams = new urlParams();
export default UrlParams;



// WEBPACK FOOTER //
// ./assets/scripts/util/urlParams.js